import hasParentClass from "shared/has-parent-class"
import {Modal} from "react-native"

const ComponentsModal = (props) => {
  const s = useShape(props)
  const {active, children, className, onRequestClose, wide, ...restProps} = props

  s.meta.cardRef = useRef()

  const onWindowMouseUp = useCallback((e) => {
    // Don't request close if the clicked element is a Haya Select option
    // Don't request close if the clicked element is a ck-body-wrapper, which could be because the user is using a CKEditor inside a modal which shouldnt close
    if (hasParentClass(e.target, ["haya-select-option", "ck-body-wrapper"])) return

    if (s.m.cardRef.current && !s.m.cardRef.current.contains(e.target)) s.p.onRequestClose()
  }, [])


  if (Platform.OS == "web") {
    useEventListener(window, "mouseup", onWindowMouseUp)
  }

  if (!active) return null

  const modalCardStyle = {
    width: "100%",
    maxHeight: "calc(100% - 100px)",
    marginTop: 50,
    marginRight: "auto",
    marginLeft: "auto",
    overflowY: "auto"
  }

  if (wide) {
    modalCardStyle.maxWidth = "calc(100% - 100px)"
  } else {
    modalCardStyle.maxWidth = 800
  }

  return (
    <Modal onBackdropPress={onRequestClose} onRequestClose={onRequestClose} transparent>
      <View
        dataSet={{class: classNames("components--modal", className)}}
        style={{position: "fixed", zIndex: 999, width: "100%", height: "100%", background: "rgba(0 0 0 / 70%)"}}
        {...restProps}
      >
        <Card
          cardRef={s.m.cardRef}
          className="modal-card"
          style={modalCardStyle}
        >
          {children}
        </Card>
      </View>
    </Modal>
  )
}

ComponentsModal.defaultProps = {
  active: true
}

ComponentsModal.propTypes = {
  active: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onRequestClose: PropTypes.func.isRequired
}

export default memo(ComponentsModal)
